(function () {
  const MARK = 'ic-whatsapp-fab';
  const GAP_PX = 28;
  const RIGHT_PX = 20;
  const MOBILE_MQ = window.matchMedia('(max-width: 767.98px)');

  function isFixed(el) {
    return el && getComputedStyle(el).position === 'fixed';
  }

  function setImportant(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function mobileNavHeight() {
    if (!MOBILE_MQ.matches) return 0;
    const nav = document.querySelector('mobile-navigation-bar.show');
    return nav ? Math.ceil(nav.getBoundingClientRect().height) : 0;
  }

  function safeInsetBottom() {
    const probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;bottom:0;visibility:hidden;pointer-events:none;padding-bottom:env(safe-area-inset-bottom)';
    document.body.appendChild(probe);
    const inset = probe.offsetHeight;
    probe.remove();
    return inset;
  }

  function findWhatsAppFab() {
    const marked = document.querySelector('.' + MARK);
    if (marked && isFixed(marked)) return marked;

    const linkSelectors =
      'a[href*="whatsapp.com"], a[href*="wa.me"], a[href*="api.whatsapp.com"]';
    let best = null;

    document.querySelectorAll(linkSelectors).forEach((link) => {
      let node = link;
      for (let depth = 0; depth < 12 && node; depth += 1) {
        if (!isFixed(node)) {
          node = node.parentElement;
          continue;
        }
        const rect = node.getBoundingClientRect();
        if (rect.width < 24 || rect.height < 24) {
          node = node.parentElement;
          continue;
        }
        if (!best || rect.width * rect.height > best.rect.width * best.rect.height) {
          best = { el: node, rect };
        }
        break;
      }
    });

    if (best) return best.el;

    document
      .querySelectorAll('[class*="dondy" i], [id*="dondy" i], [class*="chat-bubble" i]')
      .forEach((el) => {
        const root =
          isFixed(el) ? el : el.closest('[style*="position: fixed"], [style*="position:fixed"]');
        if (root && isFixed(root)) best = { el: root, rect: root.getBoundingClientRect() };
      });

    if (best) return best.el;

    const corner = [];
    document.querySelectorAll('body *').forEach((el) => {
      if (!isFixed(el)) return;
      const rect = el.getBoundingClientRect();
      if (rect.width < 40 || rect.width > 140 || rect.height < 40 || rect.height > 140) return;
      if (rect.right < window.innerWidth * 0.55 || rect.bottom < window.innerHeight * 0.55) return;
      const html = el.outerHTML.toLowerCase();
      if (
        html.includes('whatsapp') ||
        html.includes('wa.me') ||
        el.querySelector('a[href*="whatsapp"], a[href*="wa.me"]')
      ) {
        corner.push({ el, area: rect.width * rect.height });
      }
    });

    corner.sort((a, b) => b.area - a.area);
    return corner[0]?.el || null;
  }

  function layoutFloatingWidgets() {
    const whatsapp = findWhatsAppFab();
    const backToTop = document.querySelector('back-to-top.back-to-top');

    const baseBottom = mobileNavHeight() + 16 + safeInsetBottom();

    if (whatsapp) {
      whatsapp.classList.add(MARK);
      setImportant(whatsapp, 'position', 'fixed');
      setImportant(whatsapp, 'right', RIGHT_PX + 'px');
      setImportant(whatsapp, 'bottom', baseBottom + 'px');
      setImportant(whatsapp, 'z-index', '32');
      setImportant(whatsapp, 'margin', '0');
    }

    if (backToTop) {
      const waHeight = whatsapp
        ? Math.ceil(whatsapp.getBoundingClientRect().height)
        : 60;
      const bttBottom = baseBottom + waHeight + GAP_PX;

      setImportant(backToTop, 'position', 'fixed');
      setImportant(backToTop, 'right', RIGHT_PX + 'px');
      setImportant(backToTop, 'bottom', bttBottom + 'px');
      setImportant(backToTop, 'z-index', '34');
      setImportant(backToTop, 'margin', '0');
      document.documentElement.style.setProperty(
        '--ic-back-to-top-bottom',
        bttBottom + 'px'
      );
    }
  }

  function init() {
    layoutFloatingWidgets();
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layoutFloatingWidgets, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  [800, 2000, 4000, 8000].forEach((ms) => window.setTimeout(init, ms));

  MOBILE_MQ.addEventListener('change', init);
  window.addEventListener('resize', onResize);
  window.addEventListener('scroll', onResize, { passive: true });
  document.addEventListener('shopify:section:load', init);

  let moTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(layoutFloatingWidgets, 350);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
